<template>
    <div class="impersonate-notification">
        <CompassObject object="consent" size="small" />
        <p class="typographies-heading-h4 impersonate-notification__content">
            {{
                $l10n.__("Demande d'accès %(type)s (pour une durée de %(duration)s)", {
                    type: formatAccessType(authorization.type),
                    duration: `${authorization.delay.label}`,
                })
            }}
        </p>
        <div class="impersonate-notification__actions">
            <CompassButton
                ref="acceptButton"
                :label="
                    $t.__(
                        'pages.settings.complianceImpersonate.ImpersonateNotification.grant_access',
                    )
                "
                @click="handleAccept"
            />
            <CompassButton
                ref="refuseDialogButton"
                :label="
                    $t.__(
                        'pages.settings.complianceImpersonate.ImpersonateNotification.refuse_access',
                    )
                "
                type="secondary"
                @click="displayRefusalConfirmation = true"
            />
        </div>
        <CompassModal
            v-model:visible="displayRefusalConfirmation"
            size="small"
            :title="
                $t.__('pages.settings.complianceImpersonate.ImpersonateNotification.refuse_access')
            "
            class="refusal-confirmation"
            @closed="displayRefusalConfirmation = false"
        >
            <template #default>
                <p class="typographies-paragraph-medium-regular">
                    {{
                        $l10n.__(
                            'Vous êtes sur le point de refuser l’accès à votre compte aux collaborateurs Sellsy. Cette action est définitive, êtes-vous certain de vouloir refuser cet accès ?',
                        )
                    }}
                </p>
            </template>
            <template #footer>
                <div>
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="displayRefusalConfirmation = false"
                    />
                    <CompassButton
                        ref="refuseButton"
                        :label="
                            $t.__(
                                'pages.settings.complianceImpersonate.ImpersonateNotification.refuse_access',
                            )
                        "
                        type="primary-destructive"
                        @click="handleRefusal"
                    />
                </div>
            </template>
        </CompassModal>
    </div>
</template>

<script>
import { acceptAuthorization, refuseAuthorization } from 'api/impersonate/impersonateService';

export default {
    props: {
        authorization: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            displayRefusalConfirmation: false,
        };
    },
    computed: {
        formatAccessType() {
            return (type) =>
                type === 'service' ? this.$l10n.__('Services') : this.$l10n.__('Support');
        },
    },
    methods: {
        handleRefusal() {
            refuseAuthorization(this.authorization.id)
                .then(() => {
                    this.$emit('refuse-success');
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$l10n.__("L'accès a bien été refusé"),
                        close: true,
                    });
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$l10n.__('Une erreur est survenue, merci de réessayer'),
                        close: true,
                    });
                })
                .finally(() => {
                    this.displayRefusalConfirmation = false;
                });
        },
        handleAccept() {
            acceptAuthorization(this.authorization.id)
                .then(() => {
                    this.$emit('accept-success');
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$l10n.__("L'accès a bien été accepté"),
                        close: true,
                    });
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$l10n.__('Une erreur est survenue, merci de réessayer'),
                        close: true,
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.impersonate-notification {
    align-items: center;
    background: var(--colors-common-background-subtle);
    border-radius: 4px;
    display: flex;
    gap: var(--spacing-1);
    justify-content: flex-start;
    padding: var(--spacing-3);

    + .impersonate-notification {
        margin: var(--spacing-1) 0 0;
    }

    &__content {
        margin: 0;
    }

    &__actions {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
        margin-left: auto;
    }
}
</style>
<style lang="scss">
.refusal-confirmation {
    .compass-modal__modal__content {
        p {
            margin: 0;
        }
    }
    .compass-modal__modal__footer {
        div {
            display: flex;
            flex-direction: row;
            gap: var(--spacing-3);
            justify-content: flex-end;
            padding: var(--spacing-4) var(--spacing-5) var(--spacing-5);
        }
    }
}
</style>
